<Panel maxw="58rem" px="md" py="md" bg="light-" rounded="xs" border-bottom="2px solid white">

  <Panel flex items="start" line="double">

    <Panel grow line="normal">
      <Heading nm bold color="black">{title}</Heading>
      <Text sm color="body">
        {@html description}
      </Text>
    </Panel>
    
    <Icon 
      name="close"
      color="primary" hover pointer size="2" 
      nobg="light" rounded="sm"
      w=2 h=2
      on:click={() => dispatch("closed")}
      />
  </Panel>

  <div 
    transition:slide="{{delay: 20, duration: 150}}">
    <slot name="content"></slot>
  </div>

</Panel>


<script>
  import { createEventDispatcher } from 'svelte';
  import { fade, slide } from "svelte/transition";
  import { Panel, Input, Select, Heading, Label, Text, Icon } from 'svelte-stylo';

  export let
    title = '',
    description = '';

  const dispatch = createEventDispatcher()

</script>